import RouterPaths from "../../app/routePaths.js";
import { generatePath } from "react-router";
import { ROLES } from "../../app/appConstants";

export const menuDashboard = [
    {
        access: ROLES.CLIENT,
        path: generatePath(RouterPaths.main),
        title: 'Profile',
        exact: true,
    }, {
        access: ROLES.CLIENT,
        path: generatePath(RouterPaths.transactions),
        title: 'Transactions',
    }, {
        access: ROLES.ROOT,
        path: RouterPaths.config,
        title: 'Configs',
    }
];
